import { payrollActions } from "./index";
import axios from "axios";
import { toast } from 'react-toastify';
import { loginURL } from "../Library/URLs";
// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
// export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
// export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
// export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
// import { v4 as uuid } from 'uuid';


export const fetchData=(Data,Id)=>{
    return async(dispatch)=>{
        const getallEmployee=async()=>{
            let data;
            const raw ={
                "user_id": Data.user_id,
                "company_id":Data.company_id,
                "user_ses_id":Data.user_ses_id,
                "transaction_id": Id
            }
            const res= await axios.post("https://i4smart.sixthalliance.com/engine/actions/get-all-employees",raw) // returns promise
            data=res.data.data
            return data
        }
        try {
            const employees = await getallEmployee()
            dispatch(payrollActions.fetchEmployee(employees))
        } catch (error) {
            // toast.error("employee catch error"+error.message,{
            //     theme:'colored'
            // })
            console.log("employee catch error"+error.message)
        }
    }
}

export const fetchPayrollItems=(Data,Id)=>{
    return async(dispatch)=>{
        const getPayrollItems = async()=>{
            let data;
            const raw ={
                "user_id": Data.user_id,
                "company_id":Data.company_id,
                "user_ses_id":Data.user_ses_id,
                "transaction_id": Id
            }
            const res= await axios.post("https://i4smart.sixthalliance.com/engine/actions/get-all-employees",raw) // returns promise
            data=res.data.data
            return data
        }
        try {
            const employees = await getPayrollItems()
            dispatch(payrollActions.fetchEmployee(employees))
        } catch (error) {
            // toast.error("employee catch error"+error.message,{
            //     theme:'colored'
            // })
            console.log("employee catch error"+error.message)
        }
    }
}

export const fetchPayroll=(Data,Id)=>{
    return async(dispatch)=>{
        dispatch(payrollActions.loading(true))
        const getPayroll=async()=>{
            let data;
            const raw ={
                "user_id": Data.user_id,
                "company_id":Data.company_id,
                "user_ses_id": Data.user_ses_id,
                "transaction_id":Id
            }
            const res= await axios.post("https://i4smart.sixthalliance.com/engine/actions/run-payroll",raw) // returns promise
            data=res.data
            return data
        }
        try {
            const fetch= await getPayroll()
            setTimeout(() => {
                if(fetch.success){
                dispatch(payrollActions.fetchPayroll(fetch))
                dispatch(payrollActions.fetchOptionParams(false))
                dispatch(payrollActions.fetchPayrollStatus(true))
                dispatch(payrollActions.loadingModal(true))
                }else{
                    dispatch(payrollActions.fetchOptionParams(false))
                    // dispatch(payrollActions.fetchPayrollfailModal(true))
                    toast.error(fetch.message,{
                        theme:'colored'
                    })
                    // dispatch(payrollActions.fetchPayrollFailsms("can't fetch payroll"))
                }
                dispatch(payrollActions.loading(false))
            }, 1000);
        } catch (error) {
            // toast.error("can't fetch payroll"+error.message,{
            //     theme:'colored'
            // })
            console.log("can't fetch payroll"+error.message)
            dispatch(payrollActions.loading(false))
            dispatch(payrollActions.fetchOptionParams(false))
            // dispatch(payrollActions.fetchPayrollfailModal(true))
            // dispatch(payrollActions.fetchPayrollFailsms("can't fetch payroll"+error.message))
        }
       
    }
}

export const createEmployee=(PostData,User,Id)=>{
    return async(dispatch)=>{
        dispatch(payrollActions.creatingLoading(true))
        const Create =async()=>{
            let data;
            const raw ={
            "user_id": User.user_id,
            "company_id": User.company_id,
            "user_ses_id":User.user_ses_id,
            "transaction_id":Id,
            "first_name":PostData.first_name,
            "middle_name":PostData.middle_name,
            "last_name":PostData.last_name,
            "gender":PostData.gender,
            "marital_status":PostData.marital_status,
            "job_title":PostData.job_title,
            "employment_date":PostData.date,
            "ethnicity":PostData.ethnicity,
            "email_address":PostData.email,
            "phone_number":PostData.phone_number,
            "annual_salary":PostData.salary
        }
        const res= await axios.post("https://i4smart.sixthalliance.com/engine/actions/create-employee",raw)
         data=res.data
         return data
        }      
        try {
           const createEmployee=await Create()
           setTimeout(() => {
            dispatch(payrollActions.CreateEmployee(createEmployee))
            dispatch(payrollActions.creatingLoading(false))
            dispatch(payrollActions.employeeModalLoading(true))
           }, 1000);
       
        } catch (error) {
            // toast.error("create employee error" + error.message,{
            //     theme:'colored'
            // })
           console.log("create employee error" + error.message)
           dispatch(payrollActions.creatingLoading(false))
        }
         // returns promise
    }
}

export const Login=(Data)=>{
    return async(dispatch)=>{
        dispatch(payrollActions.loading(true))
        const raw ={
            "email_address": Data.email,
            "password": Data.password
        }

        await axios.post('https://i4smart.sixthalliance.com/engine/actions/super-admin-login',raw)
        .then(res=>{
            if(res.data.success===true){
                dispatch(payrollActions.getUser(res.data.data))
                dispatch(payrollActions.authLogin(true))
                dispatch(payrollActions.StepTab(3))
            }
            dispatch(payrollActions.loading(false))
        })
        .catch(err=>{
            // toast.error("Login error"+err.message)
            dispatch(payrollActions.loading(false))   
        })
          
        // try {
        //    const createlogin=await Createlogin()
        //    console.log("user"+JSON.stringify(createlogin))
        //    setTimeout(() => {
        //     if(createlogin.success===true){
        //         dispatch(payrollActions.getUser(createlogin.data))
        //         dispatch(payrollActions.authLogin(true))
        //         dispatch(payrollActions.StepTab(2))
        //     }else{
        //         toast.error(createlogin.message,{
        //             theme:'colored'
        //         })
        //         // dispatch(payrollActions.Logmsg(createlogin.message))
        //         // dispatch(payrollActions.logModal(true))
        //     }
        //    }, 1000);
        //    dispatch(payrollActions.loading(false))
        // } catch (error) {
        //     toast.error("login was not successful" + error.message,{
        //         theme:'colored'
        //     })
        //    console.log("login was not successful" + error.message)
        //    dispatch(payrollActions.loading(false))
        // }
         // returns promise
    }
}

export const UpdatePWD=(Data,User)=>{
    return async(dispatch)=>{
        dispatch(payrollActions.loading(true))
        const Createlogin =async()=>{
            let data;
            const raw ={  
            "email_address":User.email,
            "password":Data.new_pwd,
            "confirm_password" :Data.password
        }
        const res= await axios.post("https://i4smart.sixthalliance.com/engine/actions/super-admin-change-password",raw)
         data=res.data
         return data
        }      
        try {
           const createlogin=await Createlogin()
           console.log("userpwd"+JSON.stringify(createlogin))
           setTimeout(() => {
            if(createlogin.success===true){
                dispatch(payrollActions.StepTab(3))
            }else{
                toast.error(createlogin.message,{
                    theme:'colored'
                })
                // dispatch(payrollActions.Logmsg(createlogin.message))
                // dispatch(payrollActions.logModal(true))
            }
           }, 1000);
           dispatch(payrollActions.loading(false))
        } catch (error) {
            toast.error("Changing of password was not successful" + error.message,{
                theme:'colored'
            })
           console.log("Changing of password was not successful" + error.message)
           dispatch(payrollActions.loading(false))
        }
         // returns promise
    }
}



export const fetchSetUp=(Data,Id,Selected,File)=>{
    return async(dispatch)=>{
        dispatch(payrollActions.loading(true))

        const getSetUp=async(url)=>{
            let data;
            const raw ={
                "user_id":Data.user_id,
                "company_id":Data.user_id,
                "user_ses_id":Data.user_ses_id,
                "transaction_id":Id,
                "payroll_id": Selected,
                "company_image_url": url
            }
            const res= await axios.post("https://i4smart.sixthalliance.com/engine/actions/setup-company",raw) // returns promise
            data=res.data
            return data
        }

        const upload=async()=>{
            let data;
            const raw ={
                "image": File
            }
            await axios.post("https://i4smart.sixthalliance.com/engine/actions/upload-image",raw,{
                headers:{
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response=>{
                if(response.data){
                   data = response.data
                }
            })// returns promise
            return data
        }
        try {
            const Img_Url= await upload()
            const fetch= await getSetUp(Img_Url)
            // console.log("result" + JSON.stringify(fetch))
                setTimeout(() => {
                    if(fetch.success===true){
                       dispatch(payrollActions.authSetUp(fetch.success)) 
                    }else{
                        toast.error(fetch.message,{
                            theme:'colored'
                        })
                        // dispatch(payrollActions.Logmsg("Oops set up fail please try again"))
                        // dispatch(payrollActions.logModal(true))  
                    }
            }, 1000);
            dispatch(payrollActions.loading(false))
        } catch (error) {
            console.log("Set Up fail"+error.message)
            dispatch(payrollActions.loading(false))
        }
       
    }
}

export const LogOut=()=>{
    return async(dispatch)=>{    
        dispatch(payrollActions.getUser(''))
        dispatch(payrollActions.authLogin(false))
        dispatch(payrollActions.StepTab(1))
        dispatch(payrollActions.updateProxy({
            success: false,
            id: ""
        }))
        localStorage.removeItem('persist:root')
        localStorage.clear()
    }
}

export const ClearAllField=()=>{
    return async(dispatch)=>{    
        dispatch(payrollActions.GetPersonal(''))
        dispatch(payrollActions.GetEmployment(''))
        dispatch(payrollActions.GetCareerHistory(''))
        dispatch(payrollActions.GetCareer(''))
        dispatch(payrollActions.GetContact(''))
        dispatch(payrollActions.GetTime(''))
        dispatch(payrollActions.GetSalary(''))
        dispatch(payrollActions.SetEployeeDetails({
            Bio:false,
            NextOfKin:false,
            Identify:false,
            Info:false,
            Health:false,
            Review:false,
        }))
    }
}